exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".blog-post-preview{display:flex;flex-direction:column;align-items:flex-start;justify-content:center;padding:1rem .25rem;border-bottom:2px solid #eee}.blog-post-preview:last-child{border-bottom-width:0}.blog-post-preview .date,.blog-post-preview .link,.blog-post-preview .title{margin:0 auto}.blog-post-preview .date{color:#555;margin-bottom:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./src/css/index.css
// module id = ./src/css/index.css
// module chunks = 2